<template>
  <div>
    <PageTitle
      :route="$route"
    />

    <PageRowWrapper>
      <div class="col-sm-12">
        <ServiceTypeForm v-if="serviceType" :serviceType="serviceType" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import ServiceTypeForm from '@/components/settings/parameters/serviceTypes/ServiceTypeForm'

  export default {
    name: 'ServiceType',
    components: {
      PageTitle,
      PageRowWrapper,
      ServiceTypeForm
    },
    computed: {
      ...mapState({
        serviceType: state => state.servicetypes.serviceTypeById
      })
    },
    methods: {
      ...mapActions('servicetypes', ['fetchById'])
    },
    mounted () {
      this.fetchById(this.$route.params.id)
    }
  }
</script>
